export default __webpack_public_path__ + "static/media/ic_glp_custom_.11dd75db.svg";